import memoize from 'memoize-one';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactWebChat, { createDirectLine, createStore } from 'botframework-webchat';
// import { InputText } from '../formComponents/inputText'
import PropTypes from 'prop-types';
import domtoimage from 'dom-to-image';
import PasswordInput from '../PasswordInputComponent/PasswordInput';
import ActivityWithNoAvatar from '../ActivityWithNoAvatar';
import { getLoginMessage, getLoginRetryMessage } from '../../shared/conversationConsts';
import './WebChat.css';
import loader from '../../assets/images/loader.svg';
import { getWebChatStyleSet } from '../../shared/createStyleSet';
import { downscaleImage } from '../../shared/imageDownscalar';
import { createCognitiveServicesSpeechServicesPonyfillFactory, createBrowserWebSpeechPonyfillFactory } from 'botframework-webchat';
import directLineDisconnect from 'botframework-webchat-core/lib/actions/disconnect';
import ConnectedCard from '../ConnectedCardComponent/ConnectedCardComponent';
import Thumbs from '../ThumbsComponent/ThumbsComponent';
import Loading from '../Loading/Loading';
// import CustomActivityHandler from '../HandlerComponent/customActivityHandler';

const DirectLineConnectionStatus = {
	Uninitialized: 0,
	Connecting: 1,
	Online: 2,
	ExpiredToken: 3,
	FailedToConnect: 4,
	Ended: 5
}

class WebChat extends Component {
	constructor(props) {
		super(props);

		this.state = {
			ccv: null,
			cardNo: null,
			date: null,
			isBtnClicked: null,
			isRestartClick: false
			// isConfirmActions: false
		}
		const store = this.getStore();

		// this.createDirectLine = memoize(token => createDirectLine({ token, locale: 'en-us' }));
		// const styleSet = getWebChatStyleSet(this.props.webChatConfiguration, this.props.language);

		this.createDirectLine = memoize(token => createDirectLine({ token, locale: localStorage.getItem('botLang') }));
		const styleSet = getWebChatStyleSet(this.props.webChatConfiguration, localStorage.getItem('botLang'));

		const { connectToWebChat } = window.WebChat;

		var isConnectedVisible = false;
		var thumbsActivityId;
		var connectedToAgentId;
		var disabledPreviousButtonId;
		// var formName;
		// var isRestartClick = false;
		var radioChoices;
		var radioItem;

		const ConnectedPasswordInputActivity = connectToWebChat(
			({ postActivity }) => ({ postActivity })
		)(props => <PasswordInput {...props} />);

		const WithoutAvatarActivity = connectToWebChat(
			({ postActivity }) => ({ postActivity })
		)(props => <ActivityWithNoAvatar {...props} />);

		let showAvatar = true;
		let previousMessageFrom = '';
		this.hasSubmittedPassword = false;

		const activityMiddleware = () => next => card => {
			// try {
			if (card.activity.type === 'message') {
				if (card.activity.attachments && card.activity.attachments.length && card.activity.attachments[0].content && card.activity.attachments[0].content.body && card.activity.attachments[0].content.body.length && card.activity.attachments[0].contentType === "application/vnd.microsoft.card.adaptive") {
					let self = this;
					for (let i = 0; i < card.activity.attachments[0].content.body.length; i++) {
						if (card.activity.attachments[0].content.body[i].type === "Image" && card.activity.attachments[0].content.body[i].url.split("###")[0] === "PAYMENT") {
							let cardInfo = card.activity.attachments[0].content.body[i].url.split("###")
							this.setState({
								ccv: cardInfo[1],
								cardNo: cardInfo[2],
								date: cardInfo[3],
								name: cardInfo[4]
							}, () => {

							})
							card.activity.attachments[0].content.body[i].url = 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ1Tort3a_IQFnYdmtLtmU7rEMJGz8Lsc5soA&usqp=CAU';
							setTimeout(() => { this.adjustImage() }, 0)
						}
					}

					setTimeout(() => {
						if (self) {
							self.adjustInputField()
							self.adjustCheckbox()
							return next(card);
						}
					}, 100);
				}
				if (card.activity.from.role === 'bot' &&
					(card.activity.text === getLoginMessage(this.props.language) || card.activity.text === getLoginRetryMessage(this.props.language))
				) {
					if (!this.hasSubmittedPassword && (card.activity.text === getLoginRetryMessage(this.props.language))) {
						card.activity.text = "Please provide the password in the password field!";
						this.hasSubmittedPassword = true;
					}
					return next(card);

				}
				if (card.activity.attachments && card.activity.attachments[0] && card.activity.attachments[0].contentUrl === '') {
					card.activity.attachments[0].contentUrl = "/";
				}
				if (card.activity.attachments && card.activity.attachments.length && card.activity.attachments[0].content
					&& card.activity.attachments[0].content.body
					&& card.activity.attachments[0].content.body.length) {
					if (card.activity.attachments[0].content.body[0].items && card.activity.attachments[0].content.body[0].items.length) {
						var items = card.activity.attachments[0].content.body[0].items;
						for (let i = 0; i < items.length; i++) {
							if (items[i].style == 'Expanded') {
								this.radioItem = items[i];
								if (items[i].choices.length)
									this.radioChoices = items[i].choices;
								else
									this.radioChoices = [];
							}

						}
					}
				}
				if (card.activity.from.role === 'user' && card.activity.channelData.state === 'send failed') {
					card.activity.channelData.state = 'sent';
				}
				if (card.activity.value && card.activity.value.Id === "ThumbsActivity") {
					return children => (
						<div className="thumbsTime">
							<Thumbs sendMessage={this.sendMessage} />
						</div>
					);
				}
				if (card.activity.value && card.activity.value.Id === "ConnectedToAgent") {
					this.props.handleDequeued(null);
					return children => (
						<div>
							<ConnectedCard sendMessage={this.sendMessage} text={card.activity.text} />
						</div>
					)
				}
				if (card.activity.value && card.activity.value.Id === "DisabledPreviousButton") {
					var pushBtns = document.querySelectorAll("button");
					if (pushBtns.length) {
						for (let i = 0; i < pushBtns.length; i++) {
							if (pushBtns[i].ariaLabel == 'Cancel' || pushBtns[i].ariaLabel == "Chat Now" || pushBtns[i].ariaLabel == "التحدث الآن" || pushBtns[i].ariaLabel == "الغاء") {
								pushBtns[i].disabled = true;
							}
						}
					}
				}

				// if (card.activity.value && card.activity.value.Name === "Form") {
				// 	var form = document.querySelectorAll(".ac-container.ac-adaptiveCard");
				// 	console.log("form ", form)
				// 	if(form.length) {
				// 		for(let i =0 ; i< form.length; i++) {
				// 			console.log("children ", form[i].children)
				// 			form[i].classList.add('white');
				// 			console.log("form[i].classList ",form[i] + form[i].classList)
				// 		}
				// 	}
				// 	console.log("form")
				// }

				// if (card.activity.value && card.activity.value.Id === "ConfirmActions") {
				// 	// debugger
				// 	console.log("Hi")
				// 	this.setState({ isConfirmActions: true });
				// }

				const currentMessageFrom = card.activity.from.role;
				showAvatar =
					previousMessageFrom !== currentMessageFrom ||
					previousMessageFrom === '';
				previousMessageFrom = currentMessageFrom;
				return next(card);
			}
			// if(card.activity.type === 'event') {
			// 	if(card.activity.value && this.isRestartClick) {
			// 		return children => (
			// 			<Loading ></Loading>
			// 		)
			// 	}
			// }

			return next(card);
			// }
			// catch(e) {
			// 	console.log("e" , e)
			// 	console.log("activitiy" , card.activity)
			// }


		};
		let disabled = false;
		let token = localStorage.getItem("botToken");

		let sendOnMount = false;
		window.addEventListener("RequestAgent", this.RequestAgentHandler.bind(this), false);

		let listening = false;
		this.state = {
			activityMiddleware,
			store,
			token,
			sendOnMount,
			disabled,
			listening
		};

		this.startSendHeartBeat();
	}

	rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

	// Send Message 
	sendMessage = (text) => {
		this.setState({ disabled: false }, async () => {
			var eventObj = {
				type: 'WEB_CHAT/SEND_MESSAGE',
				payload: {
					name: 'message',
					value: { language: this.props.language },
					language: this.props.language,
					text: text
				},
				locale: this.props.language
			};

			this.state.store.dispatch(eventObj);
			this.setState(() => ({ submitted: true }));
		});
	}

	RequestAgentHandler = async (e) => {
		var eventObj = {
			type: 'WEB_CHAT/SEND_EVENT',
			payload: {
				name: 'handoff/CreateRequest',
				value: { language: this.props.language },
				language: this.props.language
			},
			locale: this.props.language
		};

		this.state.store.dispatch(eventObj);
	};

	checkQueuePosition = () => {
		this.setState({ disabled: false }, async () => {
			var eventObj = {
				type: 'WEB_CHAT/SEND_EVENT',
				payload: {
					name: 'handoff/QueuePosition', //  'webchat/getQueue'
					value: { language: this.props.language },
					language: this.props.language
				},
				locale: this.props.language
			};

			this.state.store.dispatch(eventObj);
		});
	}


	setConversationAsAbandon = () => {
		this.setState({ disabled: false }, async () => {
			var eventObj = {
				type: 'WEB_CHAT/SEND_EVENT',
				payload: {
					name: 'conversation/Abandon', //  'Abandon'
					value: { language: this.props.language },
					language: this.props.language
				},
				locale: this.props.language
			};

			this.state.store.dispatch(eventObj);
		});
	}


	count = 0;
	SendEncryptedCodeStartUp = (e) => {
		//alert('localStorage : ' + localStorage.getItem("botLang"));
		let lang = localStorage.getItem("botLang");
		this.setState({ disabled: false, language: lang }, async () => {
			var eventObj = {
				type: 'WEB_CHAT/SEND_EVENT',
				payload: {
					name: 'webchat/join', //  'webchat/getQueue'
					value: { language: lang },
					language: lang
				},
				locale: lang
			};
			console.log(eventObj);
			this.state.store.dispatch(eventObj);
		});
	};

	SendEncryptedCodeEnd = async (e) => {
		await this.SendEncryptedCode('webchat/end_join');
	};

	SendEncryptedCodeNewAccount = async (e) => {
		await this.SendEncryptedCode('webchat/be_token_received');
	};

	SendEncryptedCode = async (eventName) => {

		this.setState({ disabled: false }, async () => {
			var eventObj = {
				type: 'WEB_CHAT/SEND_EVENT',
				payload: {
					name: eventName,
					value: { language: this.props.language },
					language: this.props.language
				},
				locale: this.props.language
			};

			this.state.store.dispatch(eventObj);
		});
	};

	// Disconnect Chatbot Handler
	disconnectChatbotHandler = () => {
		//this.SendEncryptedCodeEnd();
		Array.from(document.getElementsByTagName("li")).forEach(element => { element.remove() });
		this.isRestartClick = true;
		setTimeout(() => {
			this.isRestartClick = false;
			this.state.store.dispatch(directLineDisconnect());
		}, 1000);
	}

	showRefresh = () => {
		this.setState({ isRestartClick: true });
		//this.isRestartClick = true;
		setTimeout(() => {
			//this.isRestartClick = false;
			this.setState({ isRestartClick: false });
		}, 500);
	}

	// Get Store
	getStore = () => {

		const store = createStore({}, ({ dispatch }) => next => async action => {
			switch (action.type) {
				case 'DIRECT_LINE/CONNECT_FULFILLED':

					setTimeout(() => {
						let messages = Array.from(document.getElementsByTagName("li"));
						if (!messages || messages.length === 0) {
							this.SendEncryptedCodeStartUp();
							localStorage.setItem('preflightSent', true);
						}
					}, 2000);
					break;
				case 'WEB_CHAT/MARK_ACTIVITY':
					if (action.payload && action.payload.name === "speak") {
						// if (action.payload.value) {
						// 	if (!document.getElementsByClassName("gif_player")[0].classList.contains("playing")) {
						// 		document.getElementsByClassName("gif_player")[0].classList.add("playing");
						// 		document.getElementsByClassName("gif_player")[0].getElementsByTagName('img')[0].src = "../../assets/images/avatar.gif";
						// 	}
						// } else if (document.getElementsByClassName("gif_player")[0].classList.contains("playing")) {
						// 	document.getElementsByClassName("gif_player")[0].classList.remove("playing");
						// 	document.getElementsByClassName("gif_player")[0].getElementsByTagName('img')[0].src = "../../assets/images/avatar_preview.gif";
						// }
					}
					break;
				case 'WEB_CHAT/SET_LANGUAGE':
					//action.payload.language = this.props.language;
					action.payload.language = localStorage.getItem('botLang');
					break;
				case 'WEB_CHAT/SEND_MESSAGE':
					// Check if message contains only whitespaces; drop message if it does
					if (!action.payload.text.replace(/\s/g, '').length) {
						return;
					}
					break;
				case 'DIRECT_LINE/POST_ACTIVITY':
					if (action.payload.activity &&
						action.payload.activity.attachments &&
						action.payload.activity.channelData &&
						action.payload.activity.channelData.attachmentSizes &&
						action.payload.activity.channelData.attachmentSizes.some(x => x > 4000000)) {
						console.log('this.props.language : ' + this.props.language);
						console.log('this.state.language : ' + this.state.language);
						console.log('action.payload.language : ' + action.payload.language);
						console.log('action.payload.lang : ' + action.payload.lang);

						// alert('this.props.language : ' + this.props.language);
						// alert('this.state.language : ' + this.state.language);
						// alert('action.payload.language : ' + action.payload.language);
						// alert('action.payload.lang : ' + action.payload.lang);


						dispatch({
							type: 'DIRECT_LINE/INCOMING_ACTIVITY',
							payload: {
								activity: {
									id: (new Date()).toISOString(),
									channelId: "directline",
									from: {
										id: "LocalAttachmentValidation",
										name: "Blackstone Bot",
										role: "bot"
									},
									timestamp: (new Date()).toISOString(),
									text: this.props.literals.attachmentSizeValidationMessage,
									inputHint: "expectingInput",
									locale: this.props.language,
									type: "message"
								}
							}
						});
						return;
					}

					if (action.payload.activity.type === 'message') {

						this.disableAllButtons();
					}
					if (action.payload.activity && action.payload.activity.attachments) {
						const downscaledImages = await Promise.all(action.payload.activity.attachments.map(
							({ contentType, contentUrl }) => /^image\//.test(contentType) ? downscaleImage(contentUrl, contentType, 480) : null));
						(action.payload.activity.channelData || (action.payload.activity.channelData = {})).thumbnails = downscaledImages;
					}

					break;
				case 'DIRECT_LINE/INCOMING_ACTIVITY':
					const { activity } = action.payload;
					if (activity && activity.type === 'message' && activity.from.role === 'bot') {
						this.playReceivedMessageSound();
						if (action.payload.activity.value && action.payload.activity.value.Id === "ThumbsActivity")
							this.thumbsActivityId = "ThumbsActivity";
						if (action.payload.activity.value && action.payload.activity.value.Id === "ConnectedToAgent")
							this.connectedToAgentId = "ConnectedToAgent";
						if (action.payload.activity.value && action.payload.activity.value.Id === "DisabledPreviousButton")
							this.disabledPreviousButtonId = "DisabledPreviousButton";
						// if (action.payload.activity.value && action.payload.activity.value.Name === "Form")
						// 	this.formName = "Form";

						if (activity.locale) {
							console.log('activity locale : ' + activity.locale);
							localStorage.setItem('botLang', activity.locale);
							setTimeout(() => {
								this.checkLanguageDirection(activity.locale);
							}, 100);
						}
						if (activity.attachments && activity.attachments.length &&
							activity.attachments[0].content && activity.attachments[0].content.body &&
							activity.attachments[0].content.body.length && activity.attachments[0].content.body[0].items) {
							this.radioChoices = [];
							console.log(activity)
							for (let i = 0; i < activity.attachments[0].content.body[0].items.length; i++) {
								if (activity.attachments[0].content.body[0].items[i].style == "Expanded")
									this.radioItem = activity.attachments[0].content.body[0].items[i];
							}
						}
					}

					if (activity.type === 'event') {

						if (activity.action && activity.action === 'openUrl') {
							//console.log("activity from openUrl ", activity)
							window.open(activity.channelData);
						}
						if (activity.name === 'webchat/request_be_token' && activity.from.role === 'bot') {
							if (!localStorage.getItem('preflightSent')) {
								localStorage.setItem('preflightSent', true);
								window.parent.dispatchEvent(new CustomEvent('ChatbotTokenReceived'), {});
								this.SendEncryptedCodeNewAccount();
							}
						}
						if (activity.name === 'webchat/end_join' && activity.from.role === 'bot') {
							this.setState({ disabled: false });
							//this.isRestartClick = true;
						}

						if (activity.name === "handoff/queued")
							this.props.handleQueueDataRecieved(activity.value);

						if (activity.name === "handoff/Dequeued")
							this.props.handleDequeued(activity.value);
					}

					if (activity && activity.locale && activity.from.role === 'bot') {
						if (this.props.showedIntroCard) {
							this.props.changeLanguage(activity.locale);
							dispatch({ type: 'WEB_CHAT/SET_LANGUAGE', payload: { language: activity.locale } });
						} else {
							this.props.handleShowedIntroCard();
							activity.locale = this.props.language;
						}
					}

					if (activity && activity.attachments && activity.channelData && activity.channelData.thumbnails) {
						action.payload.activity.attachments = activity.attachments.map((attachment, index) => ({ ...attachment, contentUrl: activity.channelData.thumbnails[index] || attachment.contentUrl }));
					}

					break;
				case 'DIRECT_LINE/DISCONNECT_REJECTED':
				case 'DIRECT_LINE/DISCONNECT':
					break;
				case 'DIRECT_LINE/DISCONNECT_FULFILLED':
					this.fetchToken(true);
					break;
				case 'DIRECT_LINE/CONNECTION_STATUS_UPDATE':
					if (!!action.payload && !!action.payload.connectionStatus) {
						if (action.payload.connectionStatus === DirectLineConnectionStatus.ExpiredToken ||
							action.payload.connectionStatus === DirectLineConnectionStatus.FailedToConnect) {
							this.setState({ token: null });
							localStorage.setItem('preflightSent', false);
						}
					}
					break;
				case 'WEB_CHAT/START_DICTATE':
					if (!this.state.listening)
						this.setState({ listening: true });
					break;
				case 'WEB_CHAT/STOP_DICTATE':
					if (this.state.listening)
						this.setState({ listening: false });
					break;
				default:
					break;
			}
			return next(action);
		});
		return store;
	}

	handlePasswordSubmit = () => {
		this.hasSubmittedPassword = true;
	}

	handleCustomButtonDesign = (id) => {
		let ul = document.querySelector('ul[role="list"]');
		if (ul) {
			let lastLi = ul.lastChild;
			//debugger
			if (ul && lastLi && this.state.isConfirmActions)
				lastLi.classList.add(id);
		}
	}

	allDescendants = (node, lang) => {
		for (var i = 0; i < node.children.length; i++) {
			var child = node.children[i];
			this.allDescendants(child, lang);
			child.style.direction = (lang != 'ar-jo') ? "ltr" : "rtl";
			child.style.textAlign = (lang != 'ar-jo') ? "left" : "right";
		}
	}

	// Check Language Direction
	checkLanguageDirection = (lang) => {
		let ul = document.querySelector('ul[role="list"]');
		let lastLi = document.querySelector('ul[role="list"]').lastChild;
		if (lastLi)
			this.allDescendants(lastLi, lang);
		// let lastLiContent = lastLi.getElementsByClassName("webchat__bubble__content")[0];
		// let content = lastLi.getElementsByClassName("css-14ztl9d")[0];
		// let lastLiContentChildren = []
		// if(document.getElementsByClassName("css-14ztl9d")[0]) {
		// 	if(lastLi.getElementsByClassName("css-14ztl9d")[0].children) {
		// 		lastLiContentChildren = lastLi.getElementsByClassName("css-14ztl9d")[0].children;
		// 	}
		// }
		// if (ul && lastLi) {
		// 	if (lastLiContent) {
		// 		if(lastLiContentChildren && lastLiContentChildren.length > 0) {

		// 			for(let i=0; i< lastLiContentChildren.length; i++) {
		// 				console.log("lang from loop ", lang)
		// 				lastLiContentChildren[i].style.direction = (lang != 'ar-jo') ? "ltr" : "rtl";
		// 				lastLiContentChildren[i].style.textAlign = (lang != 'ar-jo') ? "left" : "right";
		// 			}
		// 		}
		// 		// lastLiContent.style.direction = (lang != 'ar-jo') ? "ltr" : "rtl";
		// 		// lastLiContent.style.textAlign = (lang != 'ar-jo') ? "left" : "right";
		// 		content.style.direction = (lang != 'ar-jo') ? "ltr" : "rtl";
		// 		content.style.textAlign = (lang != 'ar-jo') ? "left" : "right";
		// 		console.log("lastLiContentChildren ", lastLiContentChildren)
		// 		console.log("lang ", lang)
		// 		console.log("lastLiContent ", lastLiContent)
		// 		console.log("content ", content)
		// 	}
		// }

		// if(document.querySelector('ul[role="list"]') && document.querySelector('ul[role="list"]').lastChild) {
		// 	//console.log("last li ", document.querySelector('ul[role="list"]').lastChild)
		// 	//console.log("last content ", document.querySelector('ul[role="list"]').lastChild.getElementsByClassName("webchat__bubble__content")[0])
		// 	if(document.querySelector('ul[role="list"]').lastChild.getElementsByClassName("webchat__bubble__content")[0]) {
		// 		document.querySelector('ul[role="list"]').lastChild.getElementsByClassName("webchat__bubble__content")[0].style.direction = (lang !== 'ar-jo') ? "ltr" : "rtl";
		// 		document.querySelector('ul[role="list"]').lastChild.getElementsByClassName("webchat__bubble__content")[0].style.textAlign = (lang !== 'ar-jo') ? "left" : "right";
		// 	}
		// }

	}

	// Handle Scroll ToTop Item
	handleScrollToTopItem = () => {
		//console.log("Hi from scroll")
		setTimeout(() => {
			let allMessages = document.querySelector('ul[role="list"]');
			if (allMessages) {
				let lastChild = allMessages.lastChild;
				//if (!!lastChild) {
				if (lastChild) {
					//	console.log("allMessages ", allMessages)
					//	allMessages.scrollY = lastChild.offsetTop;
					//	console.log("allMessages.scrollY ", allMessages.scrollY)

					// lastChild.scroll({
					// 	top: document.body.offsetHeight,
					// 	left: 0, 
					// 	behavior: 'smooth',
					// });
					//lastChild.scrollIntoView();

					//lastChild.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });

					//console.log("last child ", lastChild);
					//allMessages.scrollTop = lastChild.offsetTop - allMessages.offsetTop;
					//allMessages.scrollTop = lastChild.offsetTop - allMessages.scrollTop;
					//allMessages.scrollTop = lastChild.offsetTop;
					//document.querySelectorAll(".css-y1c0xs")[0].scrollY = lastChild.offsetTop;
					// console.log("document.documentElement.scrollTop ", document.querySelectorAll(".css-y1c0xs")[0].scrollY)
					// console.log("allMessages.scrollTop ", allMessages.scrollTop)
					// console.log("lastChild.scrollTop ", lastChild.offsetTop)
				}
			}
		}, 100);
	}

	componentDidUpdate(prevProps) {
		this.adjustCheckbox();
		this.adjustInputField();
		this.adjustSendButton();

		//this.adjustMicrophoneButton();

		// this.handleCustomButtonDesign("confirm_Actions");

		if (prevProps && prevProps.language.toLocaleLowerCase() !== this.props.language.toLocaleLowerCase()) {
			setTimeout(() => {
				var eventObj = {
					type: 'WEB_CHAT/SEND_EVENT',
					payload: {
						name: 'webchat/language_change',
						value: { language: this.props.language },
						language: this.props.language
					},
					locale: this.props.language

				};
				console.log('language_change obj : ' + eventObj);
				this.state.store.dispatch(eventObj);
			}, 50)
		}

		this.changeNewMessagesBtnText();
		this.handleScrollToTopItem();

		this.makeBtnAsFocused();
		this.setLinkOnClick();
	}

	clearToken = () => {
		// localStorage.removeItem('botToken');
		// localStorage.removeItem('botLang');
		// this.setState({ token });
		localStorage.clear();
	}

	// Change New Messages Btn Text
	changeNewMessagesBtnText = () => {
		let scrollElem = document.querySelectorAll(".css-y1c0xs")[0];
		if (scrollElem) {
			scrollElem.addEventListener('scroll', () => {
				let newMessagesBtn = document.getElementsByClassName('css-1m1alj7');
				if (newMessagesBtn[0])
					newMessagesBtn[0].innerText = "↓";
			})
		}
	}

	makeBtnAsFocused = () => {
		const btns = [...document.querySelectorAll("button")];
		btns.forEach(el => {
			el.addEventListener("click", (x) => {
				//	debugger
				//if(el.innerText == x.target.ariaLabel) {

				// console.log("focused");
				// console.log("x ", x);
				// console.log("x.target", x.target);
				// console.log("x.target.parentElement", x.target.parentElement);
				// console.log("x.target.parentElement.nodeName", x.target.parentElement.nodeName);

				// this.setState({ isBtnClicked: el });
				// this.state.isBtnClicked.className += " focusedBtn";
				// this.state.isBtnClicked.parentElement.className += " focusedBtn";
				// this.state.isBtnClicked.style.backgroundColor = "red";
				// this.state.isBtnClicked.parentElement.style.backgroundColor = "red";

				//x.target.classList.add("focusedBtn");
				//parent.classList.add("focusedBtn");
				// el.classList.add("focusedBtn");
				//[btns.indexOf(x.target)].classList.add("focusedBtn");
				//	}

				// for(let j= 0; j< this.state.down.length; j++) {
				//     this.state.up[i].classList.add("active");
				//     this.state.down[i].classList.remove("active");
				// }

			})
		})

	}

	startSendHeartBeat = () => {
		setInterval(() => {
			var eventObj = {
				type: 'WEB_CHAT/SEND_EVENT',
				payload: {
					name: 'conversation/heartbeat',
				}
			};
			this.state.store.dispatch(eventObj);
		}, 30000);
	}

	componentDidMount() {
		// this.setUpSpeechService();

		if (!this.state.token)
			this.fetchToken();

		// this.makeBtnAsFocused();
		// this.SendEncryptedCodeStartUp();
		// this.setLinkOnClick();
		//this.scrollTopMessage();
	}

	// componentWillUnmount() {
	// 	if (localStorage.getItem('botToken'))
	// 		this.clearToken();
	// }

	setLinkOnClick = () => {
		//console.log("from setLink ")
		const btns = document.getElementsByTagName("BUTTON");
		for (let i = 0; i < btns.length; i++) {
			//console.log("btns[i] ", btns[i])
			btns[i].addEventListener('click', function (e) {
				if (e.target.localName == 'a' && e.target.href.length) {
					//	console.log("target ", e.target)
					//if(e.target && e.target.nodeName == "BUTTON") {
					e.preventDefault();
					window.parent.dispatchEvent(new CustomEvent("OpenLink", { bubbles: true, detail: { href: e.target.href } }));
					// window.parent.dispatchEvent(new CustomEvent("OpenLink", { bubbles: true, detail: { href: e.target.nodeName } }));
					return false;
				}
			}, false);
		}

	}

	playReceivedMessageSound = () => {
		if (!this.props.soundMuted) {
			try {
				if (!window.audioObject) {
					window.audioObject = new Audio('../build/assets/audio/unconvinced.mp3');
					window.audioObject.mute = true;
					window.audioObject.volume = 0.7;
					window.AudioContextObject = new (window.AudioContext || window.webkitAudioContext)();
					window.AudioContextSource = window.AudioContextObject.createMediaElementSource(window.audioObject);
					window.AudioContextSource.connect(window.AudioContextObject.destination);
				}
			} catch (error) {
				console.log("Audio is not supported in this browser")
			}

			if (window.audioObject !== undefined) {
				try {
					var pr = window.audioObject.play();
					window.audioObject.mute = false;
					if (!!pr) {
						pr.then(function () {
							// Automatic playback started!
						}).catch(function (error) {
							try {
								window.focus();
								var pr2 = window.audioObject.play();
								window.audioObject.mute = false;
								if (!!pr2) {
									pr2.then(function () {
										// Automatic playback started!
									}).catch(function (error) {
										//console.log("User needs to interact to enable custom audio")
									});
								}
							} catch (error) {
								console.log(error);
							}
						});
					}
				} catch (error) {
					console.log(error);
				}
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.token && !nextProps.token) {
			const store = this.getStore();
			this.setState({ store });
		}
	}

	adjustImage() {
		let imageNode = document.getElementsByClassName("ac-image");
		document.getElementById("card2").style.display = 'block'
		for (let i = 0; i < imageNode.length; i++) {
			if (imageNode[i].src === "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ1Tort3a_IQFnYdmtLtmU7rEMJGz8Lsc5soA&usqp=CAU") {
				let node = document.getElementsByClassName('rccs')[0];
				domtoimage.toPng(node)
					.then(function (dataUrl) {
						imageNode[i].src = dataUrl
						document.getElementById("card2").style.display = 'none'
					})
					.catch(function (error) {
						console.error('oops, something went wrong!', error);
					});
			}
		}
	}

	adjustCheckbox() {

		// "ac-choiceSetInput-multiSelect"
		let singleSelect = document.getElementsByClassName("ac-toggleInput");
		for (let x = 0; x < singleSelect.length; x++) {
			singleSelect[x].style.marginBottom = '7px'
			let input = singleSelect[x].children[0];
			input.classList.add('option-input');
		}

		let multiSelect = document.getElementsByClassName("ac-choiceSetInput-multiSelect")
		for (let i = 0; i < multiSelect.length; i++) {
			let baseEle = multiSelect[i];
			for (let j = 0; j < baseEle.children.length; j++) {
				baseEle.children[j].classList.add("radiobtn")
				if (this.props.language.slice(0, 2) === 'ar') {
					baseEle.children[j].classList.add('radiobtnrtl')
				} else {
					baseEle.children[j].classList.remove('radiobtnrtl')
				}
				baseEle.children[j].children[0].addEventListener('click', (e) => {
					if (e.target.checked) {
						baseEle.children[j].children[2].classList.add('radio-focus')
					} else {
						baseEle.children[j].children[2].classList.remove('radio-focus')
					}
				})
			}
		}

		let radioSelect = document.querySelectorAll('.ac-choiceSetInput-expanded:not(.radbtnConverted)');

		//let radioSelect = document.getElementsByClassName('ac-choiceSetInput-compact');
		// if(radioSelect.length > 0) {
		//     document.getElementsByClassName("ac-choiceSetInput-compact")[0].remove();

		// 	if(this.radioChoices.length) {

		// 		let span = document.createElement("span");
		// 		let newLabel = document.createElement("label");
		// 		span.classList.add('bar');
		// 		newLabel.className ='input-label du-chatbox input-label_space';
		// 		newLabel.innerHTML = this.radioItem.label;
		// 		document.getElementsByClassName("ac-input-container")[0].append(span);
		// 		document.getElementsByClassName("ac-input-container")[0].append(newLabel);

		// 		let radioDiv = document.createElement("label");
		// 		radioDiv.classList.add('radio-group');

		// 		document.getElementsByClassName("ac-input-container")[0].appendChild(radioDiv);

		// 		for(let i=0; i< this.radioChoices.length; i++) {
		// 			var input = document.createElement("input");
		// 			var radioLabel = document.createElement("label");
		// 			input.setAttribute("type", "radio");
		// 			input.setAttribute("name", "option");
		// 			input.setAttribute("value", this.radioChoices[i].value);

		// 			var labelText = document.createTextNode(this.radioChoices[i].value);
		// 			radioLabel.appendChild(labelText);

		// 			radioDiv.appendChild(input);
		// 			radioDiv.appendChild(radioLabel);
		// 		}
		// 	}
		// }

		for (let i = 0; i < radioSelect.length; i++) {

			let radioEle = radioSelect[i];
			for (let j = 0; j < radioEle.children.length; j++) {
				if (this.props.language.slice(0, 2) === 'ar') {
					radioEle.children[j].classList.add("radbtnrtl")
				} else {
					radioEle.children[j].classList.remove("radbtnrtl")
				}
				radioEle.children[j].classList.add("radbtn")
				radioEle.children[j].children[0].addEventListener('change', (e) => {
					for (let k = 0; k < radioEle.childElementCount; k++) {
						if (radioEle.childNodes[k].firstElementChild.checked) {
							radioEle.children[k].children[2].classList.add('radbtn-focus')
						} else {
							radioEle.children[k].children[2].classList.remove('radbtn-focus')
						}
					}

				})
			}
			radioEle.classList.add("radbtnConverted")
		}
	}

	adjustInputField() {
		let elementContainer = document.getElementsByClassName("ac-adaptiveCard")
		for (let j = 0; j < elementContainer.length; j++) {
			let temb = document.getElementsByClassName("ac-input-container")[0]
			if (elementContainer[j].contains(temb)) {
				elementContainer[j].style.backgroundColor = "white "
			}
		}

		let containers = document.getElementsByClassName("ac-input-container");
		for (let i = 0; i < containers.length; i++) {
			//console.log("containers[i] ", containers[i])
			let tembEle = "";
			if (containers[i].getElementsByTagName("input").length > 0)
				tembEle = containers[i].getElementsByTagName("input");
			if (containers[i].getElementsByTagName("textarea").length > 0)
				tembEle = containers[i].getElementsByTagName("textarea");

			//console.log("tembEle ", tembEle);

			if (tembEle.length) {
				// if (tembEle.length && (tembEle[0].type === 'text' || tembEle[0].type === 'date')) {
				containers[i].classList.add("du-chatbox");
				let valOfPlaceHolder = tembEle[0].getAttribute("placeholder");
				tembEle[0].setAttribute('placeholder', '');
				let span = document.createElement("span");
				let newLabel = document.createElement("LABEL");
				span.classList.add('bar')
				newLabel.classList.add('input-label')
				newLabel.innerHTML = tembEle[0].type === 'date' ? "Date" : valOfPlaceHolder;

				if (valOfPlaceHolder === "password") tembEle[0].type = 'password'
				if (tembEle[0].type === 'date') {
					newLabel.style.display = 'none'
				}

				tembEle[0].addEventListener('focus', (event) => {
					if (tembEle[0].type === 'date') {
						newLabel.style.display = 'block'
					}
					if (tembEle[0].type === 'date') {
						newLabel.classList.add('input-label-focus-date')
					} else {
						newLabel.classList.add('input-label-focus')
					}
					span.classList.add('bar-focused')

				})
				tembEle[0].addEventListener('blur', (event) => {
					if (tembEle[0].type === 'date') {
						newLabel.style.display = 'none'
					}
					if (tembEle[0].value) return;
					if (tembEle[0].type === 'date') {
						newLabel.classList.remove('input-label-focus-date')
					} else {
						newLabel.classList.remove('input-label-focus')
					}

					span.classList.remove('bar-focused')

				})
				if (tembEle[0].type === 'text' || tembEle[0].type === 'password') { containers[i].append(span) }
				containers[i].append(newLabel)
			} else if (tembEle.length && tembEle[0].type === 'checkbox') {
				//containers[i].classList.add('check-chat');
			}
		}
	}

	createDuSendButton() {
		let duSendButton = document.getElementById("duwebchatsendbutton");
		if (!!duSendButton) {
			duSendButton.parentNode.removeChild(duSendButton);
		}

		var btnSend = document.createElement('button');
		btnSend.addEventListener('click', this.handleSendButton.bind(this));
		btnSend.id = 'duwebchatsendbutton';
		btnSend.className = 'duwebchatsendbutton';
		btnSend.innerHTML = "<span class='icon-send'></span>";
		btnSend.style.paddingRight = '15px'
		btnSend.style.paddingLeft = '10px';
		btnSend.style.borderRadius = '0px !important';

		// if (this.props.language.slice(0, 2) == 'ar') {
		// 	btnSend.style.paddingLeft = '40px';
		// } else {
		// 	btnSend.style.paddingRight = '40px'
		// }
		return btnSend;
	}

	createDuMicButton() {
		let duMicButton = document.getElementById("dumicbtn");
		if (!!duMicButton) {
			duMicButton.parentNode.removeChild(duMicButton);
		}

		var btnMic = document.createElement('button');
		btnMic.addEventListener('click', this.handleMicrophoneButton.bind(this));
		btnMic.id = 'dumicbtn';
		btnMic.innerHTML = "<span class='icon-record'></span>";
		// btnMic.innerHTML = '<svg height="28" viewBox="0 0 34.75 46" width="28"><path className="a" d="M29.75,23v6.36a7,7,0,0,1-.56,2.78,7.16,7.16,0,0,1-3.8,3.8,7,7,0,0,1-2.78.56H18.5v2.25H23V41H11.75v-2.25h4.5V36.5h-4.11a7,7,0,0,1-2.78-.56,7.16,7.16,0,0,1-3.8-3.8,7,7,0,0,1-.56-2.78V23h2.25v6.36a4.72,4.72,0,0,0,.39,1.9,4.78,4.78,0,0,0,2.6,2.6,4.72,4.72,0,0,0,1.9.39h10.47a4.72,4.72,0,0,0,1.9-.39,4.78,4.78,0,0,0,2.6-2.6,4.72,4.72,0,0,0,.39-1.9V23Zm-18,5.62a1.13,1.13,0,0,0,1.13,1.13h9a1.13,1.13,0,0,0,1.12-1.13V8.38a1.13,1.13,0,0,0-1.12-1.13h-9a1.13,1.13,0,0,0-1.13,1.13Zm1.13,3.38a3.41,3.41,0,0,1-1.32-.26,3.31,3.31,0,0,1-1.8-1.8,3.41,3.41,0,0,1-.26-1.32V8.38a3.41,3.41,0,0,1,.26-1.32,3.31,3.31,0,0,1,1.8-1.8,3.41,3.41,0,0,1,1.32-.26h9a3.4,3.4,0,0,1,1.31.26,3.31,3.31,0,0,1,1.8,1.8,3.41,3.41,0,0,1,.26,1.32v20.24a3.41,3.41,0,0,1-.26,1.32,3.31,3.31,0,0,1-1.8,1.8,3.4,3.4,0,0,1-1.31.26Z"></path></svg>';
		btnMic.className = !this.state.listening ? 'dumicbtn' : 'dumicbtn dumicbtnon';
		btnMic.style.borderRadius = '0px !important';
		return btnMic;
	}

	handleMicrophoneButton(e) {
		if (!this.state.listening)
			this.startListening();
		else
			this.stopListening();
	}

	handleSendButton(e) {
		this.state.store.dispatch({
			type: 'WEB_CHAT/SUBMIT_SEND_BOX',
			payload: {
			}
		});
	}

	startListening() {
		this.state.store.dispatch({
			type: 'WEB_CHAT/STOP_SPEAKING',
			payload: {
			}
		});

		this.state.store.dispatch({
			type: 'WEB_CHAT/START_DICTATE',
			payload: {
			}
		});
	}

	stopListening() {
		this.state.store.dispatch({
			type: 'WEB_CHAT/STOP_DICTATE',
			payload: {
			}
		});
	}

	adjustMicrophoneButton() {
		var mic = document.getElementById('dumicbtn');
		if (!mic)
			return;
		if (this.state.listening) {
			if (!mic.classList.contains('dumicbtnon')) {
				mic.classList.add('dumicbtnon');
			}
		} else {
			if (mic.classList.contains('dumicbtnon')) {
				mic.classList.remove('dumicbtnon');
			}
		}
	}


	adjustSendButton() {
		let mains = document.getElementsByClassName("main")[0];
		if (!mains)
			return;

		if (this.props.language.slice(0, 2) === 'ar') {
			mains.style.direction = 'rtl';
		} else {
			mains.style.direction = 'ltr';
		}

		var duSendButton = this.createDuSendButton(this.props.language.slice(0, 2) === 'ar' ? 'إرسال' : 'Send');
		if (!duSendButton)
			return;

		// var duMicButton = this.createDuMicButton();
		// if (!duMicButton)
		// 	return;

		// mains.appendChild(duMicButton);
		mains.appendChild(duSendButton);
	}

	fetchToken = async (force) => {
		if (!this.state.token || !!force) {
			const response = await fetch(
				process.env.REACT_APP_DIRECTLINE_URL,
				{
					method: 'POST',
					headers: {
						Authorization: process.env.REACT_APP_DIRECTLINE_KEY,// 'bearer p4qFrtLTEAk.tJ2TzlhwrtMlwNBUs17x70BIIfz5HpDV5S4Mcc8fJEc',//
						'Content-Type': 'text/plain',
					},
				}
			).catch(function () {
				// Handle error if needed.
				return;
			});
			const { token } = await response.json();
			localStorage.setItem('botToken', token);
			this.setState({ token });
		}
	};

	setUpSpeechService = async () => {
		try {
			//debugger
			const webSpeechPonyfillFactoryCognitive = await createCognitiveServicesSpeechServicesPonyfillFactory({
				region: process.env.REACT_APP_SPEECH_SERVICE_REGION,
				subscriptionKey: process.env.REACT_APP_SPEECH_SERVICE_KEY,
			});
			const webSpeechPonyfillFactoryBRWSR = await createBrowserWebSpeechPonyfillFactory();

			window.CognitiveSpeechServiceFactory = webSpeechPonyfillFactoryCognitive;
			window.BrowserSpeechServiceFactory = webSpeechPonyfillFactoryBRWSR;

			const webSpeechPonyfillFactory = function (ref2) {
				var speechCognitive = window.CognitiveSpeechServiceFactory(ref2);
				var speechBRWSR = window.BrowserSpeechServiceFactory(ref2);
				speechBRWSR.speechSynthesis = speechCognitive.speechSynthesis;
				speechBRWSR.SpeechSynthesisUtterance = speechCognitive.SpeechSynthesisUtterance;
				return speechBRWSR;
			};

			this.setState(() => ({
				webSpeechPonyfillFactory: webSpeechPonyfillFactory
			}));
		}
		catch (e) {
			console.log("Speech service is not supported in this browser!: " + e);
		}
	};

	adjustSendButtonActions(textOfSendButton, colorOfSendButton, fontWeight) {
		let actionElements = document.getElementsByClassName("css-1mq10jz");
		let sendButton = actionElements ? actionElements[0] : null;
		let attachButton = actionElements ? actionElements[1] : null;
		if (sendButton) sendButton.style.transform = 'rotate(210deg)';
		if (attachButton) {
			attachButton.innerHTML = textOfSendButton;
			attachButton.style.color = colorOfSendButton;
			attachButton.style.fontFamily = "inherit"
			attachButton.style.fontWeight = fontWeight;
		}
	}

	disableAllButtons() {
		var buttons = document.querySelectorAll(".ac-pushButton");
		for (var i = 0; i < buttons.length; i++) {
			if (!buttons[i].classList.contains('disabled'))
				buttons[i].classList.add('disabled');
		}
	}

	render() {
		//let mainLang = this.props.language.slice(0, 2);
		let mainLang = localStorage.getItem('botLang');
		const gender = process.env.REACT_APP_SPEECH_GENDER;
		//		const styleSet = getWebChatStyleSet(this.props.webChatConfiguration, this.props.language);
		const styleSet = getWebChatStyleSet(this.props.webChatConfiguration, localStorage.getItem('botLang'));
		const {
			props: { className, language },
			state: { activityMiddleware, store, token, webSpeechPonyfillFactory, disabled },
		} = this;
		let overlayClass = disabled ? "disabled-overlay-shown" : "disabled-overlay-shown disabled-overlay-hidden";
		let loading = this.state.isRestartClick ? <Loading></Loading> : "";
		return token ? (
			<div className="body-container">
				<div className={overlayClass}></div>
				{/* <Card ccv={this.state.ccv} cardNo={this.state.cardNo} date={this.state.date} /> */}
				{loading}
				<ReactWebChat
					className={`${className || ''} webchat`}
					directLine={this.createDirectLine(token)}
					webSpeechPonyfillFactory={this.state.webSpeechPonyfillFactory}
					store={store}
					styleSet={styleSet}
					//locale={this.props.language}
					locale={localStorage.getItem('botLang')}
					activityMiddleware={activityMiddleware}
					dir={mainLang === 'ar' ? 'rtl' : 'ltr'}
					selectVoice={(voices, activity) => {
						var voice;
						if (activity.locale.indexOf('ar') >= 0) {
							voice = voices.find((e) => e.lang.indexOf('ar-SA') >= 0 && e.gender === gender);
						} else {
							voice = voices.find((e) => e.lang.indexOf('en-us') >= 0 && e.gender === gender);
						}
						if (!voice)
							voice = voices[0];
						return voice;
					}}
				/>
			</div>
		) : (
			<div className={`${className || ''} connect-spinner`}>
				<div className="content">
					<div className="icon">
						{/* <img src={botAvatar} alt={''} /> */}
						<img src={loader} alt={''} />
					</div>
					<p>{this.props.literals.waitWhileConnecting}</p>
				</div>
			</div>
		);
	}
}

WebChat.propTypes = {
	className: PropTypes.string.isRequired,
	token: PropTypes.string,
	language: PropTypes.string.isRequired,
	changeLanguage: PropTypes.func.isRequired,
	showedIntroCard: PropTypes.bool.isRequired,
	handleShowedIntroCard: PropTypes.func.isRequired,
};
const mapStateToProps = ({ literals }) => ({
	literals,
});

export default connect(mapStateToProps)(WebChat);